/* Qué colaboradores enseña el panel. Lógica pura: no importa nada, y qa/perfiles.test.mjs la prueba. */

// Las fases son las del reparto del motor (`tools/gen-agents.mjs`). Desde agosto de 2026 el panel seguía
// agrupando por «Borrador» y «Revisión», que ya no existían: el editor y el corrector no salían en el
// desplegable. qa/perfiles.test.mjs compara esta lista con la del motor para que no vuelva a pasar.
export const PHASES = ["Concepto", "Escritura", "Reescritura", "Publicación"] as const;

/**
 * Los perfiles que se ofrecen (Rais, 10-oct-2026): dos asesores y un corrector. El coach para lo de antes
 * y lo de durante; el editor de desarrollo para la reescritura; y un solo corrector. Los demás siguen en
 * el motor —no se borra nada—, pero no se enseñan. El orden es el del trabajo.
 */
export const A_LA_VISTA = ["coach", "editor", "copyeditor"] as const;
/** Con quién se abre el panel: el coach literario (Rais, 10-oct-2026: «por defecto pon el coach, no el corrector»). */
export const DE_ENTRADA: (typeof A_LA_VISTA)[number] = "coach";

/** Los colaboradores del desplegable: los tres de siempre y, si hay otro elegido (el del certificado), ese también. */
export function perfiles<T extends { id: string }>(agents: T[], elegido: string): T[] {
  const lista = A_LA_VISTA.map((id) => agents.find((a) => a.id === id)).filter((a): a is T => !!a);
  const otro = agents.find((a) => a.id === elegido && !lista.includes(a));
  return otro ? [...lista, otro] : lista;
}
